export function isValidAccessTokenEvent(event) {
  if (!event) return false;

  console.log("Validating storage event:", event);
  
  // key correcta
  if (event.key !== "access_token") return false;

  // debe existir valor
  if (!event.newValue) return false;

  const token = event.newValue;

  // tipo
  if (typeof token !== "string") return false;

  // formato JWT básico
  const parts = token.split(".");
  if (parts.length !== 3) return false;

  // tamaño mínimo
  if (token.length < 20) return false;

  return true;
}